import { render, staticRenderFns } from "./folders-activity.vue?vue&type=template&id=49ad8ed8&scoped=true"
import script from "./folders-activity.vue?vue&type=script&lang=js"
export * from "./folders-activity.vue?vue&type=script&lang=js"
import style0 from "./folders-activity.vue?vue&type=style&index=0&id=49ad8ed8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ad8ed8",
  null
  
)

export default component.exports